import React from 'react';
import { useSelector } from 'react-redux';
import { toggleActivePrompt } from '../../../../store/slices/pageSlice';
import { selectActivePrompt } from '../../../../store/selectors/pageSelectors';
import { BlockName } from '../../../../shared/types/projectTypes';
import { useAppDispatch } from '../../../../store/store';
import s from './TopToolbar.module.css';
import IconRemoveBackground from '../../../../shared/ui/icons/IconRemoveBackground';
import PremiumFeatureTooltip from '../../../text-editor-page/widgets/premium-feature-tooltip/PremiumFeatureTooltip';
import FullScreenButton from '../../../text-editor-page/widgets/tools-buttons/FullScreenButton';
import { selectSelectedImage } from '../../../../store/selectors/imageSelectors';
import { removeBackgroundImageUrl } from '../../../../shared/api/imageProjectApi';
import { toast } from 'react-toastify';
const TopToolbar: React.FC = () => {
    const dispatch = useAppDispatch();
    const activePrompt = useSelector(selectActivePrompt);
    const selectedImage = useSelector(selectSelectedImage);

    const handleRemoveBG = async () => {
        if (!selectedImage?.image?.id) return;
        try {
            await dispatch(removeBackgroundImageUrl({ imageId: selectedImage.image.id }));
            toast.success('Image background removed successfully');
        } catch (error: any) {
            toast.error(error?.message || 'Failed to remove image background');
        }
    };

    return (
        <div className={s.container}>
            <div className={s.right_container}>
                <p className={s.header}>
                    Image size:&nbsp;
                    <span className={s.text}>
                        {selectedImage?.image?.transformation?.width}×
                        {selectedImage?.image?.transformation?.height}
                    </span>
                </p>
            </div>

            <div className={s.left_container}>
                <FullScreenButton />
                <button
                    className={`${s.button} ${activePrompt === 'remove_background' ? s.active : ''} `}
                    onClick={handleRemoveBG}
                >
                    <IconRemoveBackground width={18} height={18} />
                    <span className={s.text}>Remove Background</span>
                    <div className={`${s.diamond_wrapper}`}>
                        <PremiumFeatureTooltip />
                    </div>
                </button>
            </div>
        </div>
    );
};

export default TopToolbar;
